import { Component, OnInit } from '@angular/core';
import {ServicesComponent} from "../services.component";
import {WebDesignComponent} from "./web-design.component";

@Component({
  selector: 'app-logo',
  template: `
     <div class="service-detail" id="top">
        <h2><span class="bottomBorder" style="padding-bottom: 4%;">LOGO</span> & GRAPHICS</h2>
        <div class="scale-less-margin"></div>
        <article>Logos can be simple text based logos, text and icon all the way to a logo with character design.
          We know how important it is to make design work relevant and look good so we go the extra mile to deliver something of the highest standards. </article>
        <article style="margin-bottom: 6%">At Creative Digital we offer a wide range of logo and graphic design services.
          If you require us to go the extra mile we can also design complete branding for your company, product or service.</article>
        <div class="details-container first">
          <div class="checked"></div>
          <h5>Logo design</h5></div>
        <p style="display: block" class="slider">Logos can be simple text based logos, text and icon all the way to a logo with character design.  We know how important it is to make design work relevant and look good so we go the extra mile to deliver something of the highest standards. </p>
        <div class="details-container second">
          <div class="checkMark"></div>
          <h5>Brand & identity</h5></div>
        <p class="slider">Every business or product starts with an idea.  We work closely with our clients to develop new ideas or build on existing work to develop stuning  graphics & concepts for branding. <br>
          From a new service, product or a whole business we can draw up concepts and develop creative ideas to design and build your brand. </p>
        <div class="details-container third">
          <div class="checkMark"></div>
          <h5>Infographics & maps</h5></div>
        <p class="slider">Creative Digital designs graphics for information purposes from infographics to maps.
           A good graphical map can help people navigate there way to different places easily and help you steer people to points of interest effectively. </p>
      </div>
  `,
  styleUrls: ['./logo.component.css']
})
export class LogoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.slider();
    WebDesignComponent.firstStart(this, 3);
  }

  slider () {
    $('.first').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.second').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.third').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.forth').click(function () {
      WebDesignComponent.initializeSlide(this);
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/services/descriptionComponents/logo.component.ts